import { jsx } from "react/jsx-runtime";
import { ControlTowerErrorTypes } from "./ControlTowerError.types.js";
import { ContentLayout } from "@ane/ui-components/lib/components/ContentLayout";
import { MessageBarType } from "@ane/ui-components/lib/components/MessageBar";
import { ErrorMessage } from "@ane/ui-components";
import { FileATicketButton } from "./FileATicketButton.js";
const ControlTowerError = ({
  errorType = ControlTowerErrorTypes.legacy,
  displayErrorPrefix,
  displayErrorMessage,
  correlationId,
  errorContext,
  onRetry,
  hideDriButton,
  onDismiss
}) => {
  const ErrorComponent = () => /* @__PURE__ */ jsx(
    ErrorMessage,
    {
      onDismiss,
      heading: displayErrorPrefix,
      message: displayErrorMessage,
      loggingProps: {
        errorContext,
        correlationId,
        errorCorrelationId: errorContext == null ? void 0 : errorContext.errorCorrelationId
      },
      messageBarProps: {
        messageBarType: MessageBarType.error,
        ariaLabel: `${displayErrorPrefix}: ${displayErrorMessage}`,
        actions: !hideDriButton ? /* @__PURE__ */ jsx(
          FileATicketButton,
          {
            issue: displayErrorPrefix != null ? displayErrorPrefix : `${displayErrorMessage}`,
            errorMessage: displayErrorMessage,
            correlationId: correlationId != null ? correlationId : "unknown"
          }
        ) : void 0
      },
      onRetry
    }
  );
  return errorType === ControlTowerErrorTypes.legacy ? /* @__PURE__ */ jsx(ContentLayout, { children: /* @__PURE__ */ jsx(ErrorComponent, {}) }) : /* @__PURE__ */ jsx(ErrorComponent, {});
};
export {
  ControlTowerError
};
//# sourceMappingURL=ControlTowerError.js.map
